import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const PrivacySettingsStep = ({ formData, onChange }) => {
  const accessLevelOptions = [
    { value: 'public', label: 'Public Access', description: 'Anyone with link can view' },
    { value: 'password', label: 'Password Protected', description: 'Requires password to access' },
    { value: 'email', label: 'Email Verification', description: 'Requires email verification' },
    { value: 'invite', label: 'Invite Only', description: 'Only invited visitors can access' }
  ];

  const downloadPermissionOptions = [
    { value: 'all', label: 'All Files', description: 'Allow download of all media' },
    { value: 'selected', label: 'Selected Only', description: 'Visitors can select files to download' },
    { value: 'none', label: 'No Downloads', description: 'View only, no downloads' }
  ];

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="bg-card border border-border rounded-xl p-4 md:p-6">
        <h3 className="text-lg md:text-xl font-semibold mb-4 md:mb-6">Access Control</h3>
        
        <div className="space-y-4 md:space-y-5">
          <Select
            label="Access Level"
            options={accessLevelOptions}
            value={formData?.accessLevel}
            onChange={(value) => onChange('accessLevel', value)}
            required
            placeholder="Choose access level"
          />

          <Select
            label="Download Permissions"
            options={downloadPermissionOptions}
            value={formData?.downloadPermission}
            onChange={(value) => onChange('downloadPermission', value)}
            required
            placeholder="Set download permissions"
          />
        </div>
      </div>
      <div className="bg-card border border-border rounded-xl p-4 md:p-6">
        <h3 className="text-lg md:text-xl font-semibold mb-4 md:mb-6">Visitor Tracking</h3>
        
        <div className="space-y-4">
          <Checkbox
            label="Require visitor registration"
            description="Collect name, email, and phone before gallery access"
            checked={formData?.requireRegistration}
            onChange={(e) => onChange('requireRegistration', e?.target?.checked)}
          />

          <Checkbox
            label="Track visitor activity"
            description="Monitor gallery views, downloads, and last visit timestamps"
            checked={formData?.trackActivity}
            onChange={(e) => onChange('trackActivity', e?.target?.checked)}
          />

          <Checkbox
            label="Enable analytics dashboard"
            description="View detailed visitor statistics and download history"
            checked={formData?.enableAnalytics}
            onChange={(e) => onChange('enableAnalytics', e?.target?.checked)}
          />

          <Checkbox
            label="Send access notifications"
            description="Receive email notifications when visitors access the gallery"
            checked={formData?.sendNotifications}
            onChange={(e) => onChange('sendNotifications', e?.target?.checked)}
          />
        </div>
      </div>
      <div className="bg-card border border-border rounded-xl p-4 md:p-6">
        <h3 className="text-lg md:text-xl font-semibold mb-4 md:mb-6">Gallery Features</h3>
        
        <div className="space-y-4">
          <Checkbox
            label="Enable comments"
            description="Allow visitors to leave comments on media files"
            checked={formData?.enableComments}
            onChange={(e) => onChange('enableComments', e?.target?.checked)}
          />

          <Checkbox
            label="Enable favorites"
            description="Let visitors mark their favorite photos/videos"
            checked={formData?.enableFavorites}
            onChange={(e) => onChange('enableFavorites', e?.target?.checked)}
          />

          <Checkbox
            label="Auto-sync with Google Drive"
            description="Automatically update gallery when new files are added to folders"
            checked={formData?.autoSync}
            onChange={(e) => onChange('autoSync', e?.target?.checked)}
          />

          <Checkbox
            label="Watermark protection"
            description="Add watermark to displayed images (downloads remain original)"
            checked={formData?.enableWatermark}
            onChange={(e) => onChange('enableWatermark', e?.target?.checked)}
          />
        </div>
      </div>
      <div className="bg-success/10 border border-success rounded-xl p-4 md:p-5">
        <div className="flex items-start gap-3">
          <Icon name="Shield" size={20} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm md:text-base font-medium text-success mb-1">Security Enabled</p>
            <p className="text-xs md:text-sm text-muted-foreground">
              Your gallery will be protected with the selected access controls and visitor tracking features
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacySettingsStep;